import { ReactComponent as FileUploadIcon } from '@/assets/img/file-upload-icon.svg';
import './FileUploader.scss';
import { useRef, useState } from 'react';
import Lottie from 'lottie-react';
import progressAnimation from '@/assets/animation/loading.json';
import { ReactComponent as EditIcon } from '@/assets/img/edit-icon-svg.svg';
import { showNotification } from '@/utils/notificationUtils';
import FileViewer from '@/components/FileViewer/FileViewer';

type FileUploaderProps = {
  onUpload: (formData: FormData) => void;
  url?: string;
  isUploading: boolean;
  disabled?: boolean;
  hideHelperText?: boolean;
};
export const FileUploader = ({
  onUpload,
  url,
  isUploading,
  disabled,
  hideHelperText,
}: FileUploaderProps) => {
  const fileInputRef = useRef(null);
  const [fileViewerUrl, setFileViewerUrl] = useState<string>();
  const onFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files as FileList;
    //setImageUrl('');
    UploadProfilePic(selectedFiles?.[0]);
  };

  const UploadProfilePic = async (selectedFiles: any) => {
    if (selectedFiles?.size > 1500000) {
      showNotification({
        type: 'info',
        title: 'Uploaded image should be less than 1.5 mb .',
      });
      return false;
    }
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];

    if (!validTypes.includes(selectedFiles.type)) {
      showNotification({
        type: 'info',
        title: 'Only png and jpg images are allowed',
      });
      return false;
    }

    if (selectedFiles) {
      const formData = new FormData();
      formData.append('file', selectedFiles);
      onUpload(formData);
    }
  };

  const onUploadImageHandler = () => {
    if (!isUploading && fileInputRef && fileInputRef.current) {
      (fileInputRef.current as any).click();
    }
  };
  const openImage = () => {
    if (url && hideHelperText) {
      setFileViewerUrl(url);
    }
  };
  return (
    <div className="file-uploader">
      <div className="image-section" onClick={onUploadImageHandler}>
        {url ? (
          !hideHelperText ? (
            <span className="image-holder">
              <img src={url} />{' '}
              {!isUploading && !disabled && (
                <span>
                  {' '}
                  <EditIcon className="edit-icon" />{' '}
                </span>
              )}
            </span>
          ) : (
            <span className="image-holder">
              <img src={url} onClick={openImage} />{' '}
              {!isUploading && !disabled && (
                <span>
                  {' '}
                  <EditIcon className="edit-icon" />{' '}
                </span>
              )}
            </span>
          )
        ) : (
          <FileUploadIcon />
        )}
        {isUploading && <Lottie className="loader-animation" animationData={progressAnimation} />}

        <input
          type="file"
          onChange={onFileSelect}
          ref={fileInputRef}
          hidden
          placeholder="Attribute name"
          disabled={disabled}
        />
      </div>
      {!hideHelperText && (
        <p>
          Upload <b>Pet Picture</b> in <b>JPG</b> or <b>PNG</b> format <br />
          maximum <b>1.5MB</b> in <b>1:1</b> ratio
        </p>
      )}
      {fileViewerUrl && (
        <FileViewer fileUrl={fileViewerUrl} onClose={() => setFileViewerUrl(undefined)} />
      )}
    </div>
  );
};
